import type { VoidComponent } from "solid-js";
import { IconButton } from "../../../components/button/Button";
import { useTranslation } from "../../../state/i18n";
import PreviewService from "../../../services/PreviewService";

const HeaderPreviewButton: VoidComponent = () => {
  const { t } = useTranslation();

  return (
    <IconButton
      icon="eye"
      iconType="outline"
      aria-label={t(($) => $.FORM_EDITOR_HEADER_PREVIEW_BUTTON)}
      variant="secondary"
      onClick={() => PreviewService.openPreview()}
    />
  );
};

export default HeaderPreviewButton;
